export default {
    area_list: [{
        text: '台灣',
        value: 710000,
        children: [{
            text: '台北市',
            value: 710100,
            children: [{
                text: '中正區',
                value: 710101
            }, {
                text: '大同區',
                value: 710102
            }, {
                text: '中山區',
                value: 710103
            }, {
                text: '松山區',
                value: 710104
            }, {
                text: '大安區',
                value: 710105
            }, {
                text: '萬華區',
                value: 710106
            }, {
                text: '信義區',
                value: 710107
            }, {
                text: '士林區',
                value: 710108
            }, {
                text: '北投區',
                value: 710109
            }, {
                text: '內湖區',
                value: 710110
            }, {
                text: '南港區',
                value: 710111
            }, {
                text: '文山區',
                value: 710112
            }, {
                text: '其它區',
                value: 710199
            }]
        }, {
            text: '高雄市',
            value: 710200,
            children: [{
                text: '新興區',
                value: 710201
            }, {
                text: '前金區',
                value: 710202
            }, {
                text: '芩雅區',
                value: 710203
            }, {
                text: '鹽埕區',
                value: 710204
            }, {
                text: '鼓山區',
                value: 710205
            }, {
                text: '旗津區',
                value: 710206
            }, {
                text: '前鎮區',
                value: 710207
            }, {
                text: '三民區',
                value: 710208
            }, {
                text: '左營區',
                value: 710209
            }, {
                text: '楠梓區',
                value: 710210
            }, {
                text: '小港區',
                value: 710211
            }, {
                text: '東沙群島',
                value: 710212
            }, {
                text: '南沙群島',
                value: 710213
            }, {
                text: '苓雅區',
                value: 710241
            }, {
                text: '仁武區',
                value: 710242
            }, {
                text: '大社區',
                value: 710243
            }, {
                text: '岡山區',
                value: 710244
            }, {
                text: '路竹區',
                value: 710245
            }, {
                text: '阿蓮區',
                value: 710246
            }, {
                text: '田寮區',
                value: 710247
            }, {
                text: '燕巢區',
                value: 710248
            }, {
                text: '橋頭區',
                value: 710249
            }, {
                text: '梓官區',
                value: 710250
            }, {
                text: '彌陀區',
                value: 710251
            }, {
                text: '永安區',
                value: 710252
            }, {
                text: '湖內區',
                value: 710253
            }, {
                text: '鳳山區',
                value: 710254
            }, {
                text: '大寮區',
                value: 710255
            }, {
                text: '林園區',
                value: 710256
            }, {
                text: '鳥松區',
                value: 710257
            }, {
                text: '大樹區',
                value: 710258
            }, {
                text: '旗山區',
                value: 710259
            }, {
                text: '美濃區',
                value: 710260
            }, {
                text: '六龜區',
                value: 710261
            }, {
                text: '內門區',
                value: 710262
            }, {
                text: '杉林區',
                value: 710263
            }, {
                text: '甲仙區',
                value: 710264
            }, {
                text: '桃源區',
                value: 710265
            }, {
                text: '那瑪夏區',
                value: 710266
            }, {
                text: '茂林區',
                value: 710267
            }, {
                text: '茄萣區',
                value: 710268
            }, {
                text: '其它區',
                value: 710299
            }]
        }, {
            text: '台南市',
            value: 710300,
            children: [{
                text: '中西區',
                value: 710301
            }, {
                text: '東區',
                value: 710302
            }, {
                text: '南區',
                value: 710303
            }, {
                text: '北區',
                value: 710304
            }, {
                text: '安平區',
                value: 710305
            }, {
                text: '安南區',
                value: 710306
            }, {
                text: '永康區',
                value: 710339
            }, {
                text: '歸仁區',
                value: 710340
            }, {
                text: '新化區',
                value: 710341
            }, {
                text: '左鎮區',
                value: 710342
            }, {
                text: '玉井區',
                value: 710343
            }, {
                text: '楠西區',
                value: 710344
            }, {
                text: '南化區',
                value: 710345
            }, {
                text: '仁德區',
                value: 710346
            }, {
                text: '關廟區',
                value: 710347
            }, {
                text: '龍崎區',
                value: 710348
            }, {
                text: '官田區',
                value: 710349
            }, {
                text: '麻豆區',
                value: 710350
            }, {
                text: '佳里區',
                value: 710351
            }, {
                text: '西港區',
                value: 710352
            }, {
                text: '七股區',
                value: 710353
            }, {
                text: '將軍區',
                value: 710354
            }, {
                text: '學甲區',
                value: 710355
            }, {
                text: '北門區',
                value: 710356
            }, {
                text: '新營區',
                value: 710357
            }, {
                text: '後壁區',
                value: 710358
            }, {
                text: '白河區',
                value: 710359
            }, {
                text: '東山區',
                value: 710360
            }, {
                text: '六甲區',
                value: 710361
            }, {
                text: '下營區',
                value: 710362
            }, {
                text: '柳營區',
                value: 710363
            }, {
                text: '鹽水區',
                value: 710364
            }, {
                text: '善化區',
                value: 710365
            }, {
                text: '大內區',
                value: 710366
            }, {
                text: '山上區',
                value: 710367
            }, {
                text: '新市區',
                value: 710368
            }, {
                text: '安定區',
                value: 710369
            }, {
                text: '其它區',
                value: 710399
            }]
        }, {
            text: '台中市',
            value: 710400,
            children: [{
                text: '中區',
                value: 710401
            }, {
                text: '東區',
                value: 710402
            }, {
                text: '南區',
                value: 710403
            }, {
                text: '西區',
                value: 710404
            }, {
                text: '北區',
                value: 710405
            }, {
                text: '北屯區',
                value: 710406
            }, {
                text: '西屯區',
                value: 710407
            }, {
                text: '南屯區',
                value: 710408
            }, {
                text: '太平區',
                value: 710431
            }, {
                text: '大里區',
                value: 710432
            }, {
                text: '霧峰區',
                value: 710433
            }, {
                text: '烏日區',
                value: 710434
            }, {
                text: '豐原區',
                value: 710435
            }, {
                text: '后里區',
                value: 710436
            }, {
                text: '石岡區',
                value: 710437
            }, {
                text: '東勢區',
                value: 710438
            }, {
                text: '和平區',
                value: 710439
            }, {
                text: '新社區',
                value: 710440
            }, {
                text: '潭子區',
                value: 710441
            }, {
                text: '大雅區',
                value: 710442
            }, {
                text: '神岡區',
                value: 710443
            }, {
                text: '大肚區',
                value: 710444
            }, {
                text: '沙鹿區',
                value: 710445
            }, {
                text: '龍井區',
                value: 710446
            }, {
                text: '梧棲區',
                value: 710447
            }, {
                text: '清水區',
                value: 710448
            }, {
                text: '大甲區',
                value: 710449
            }, {
                text: '外埔區',
                value: 710450
            }, {
                text: '大安區',
                value: 710451
            }, {
                text: '其它區',
                value: 710499
            }]
        }, {
            text: '金門縣',
            value: 710500,
            children: [{
                text: '金沙鎮',
                value: 710507
            }, {
                text: '金湖鎮',
                value: 710508
            }, {
                text: '金寧鄉',
                value: 710509
            }, {
                text: '金城鎮',
                value: 710510
            }, {
                text: '烈嶼鄉',
                value: 710511
            }, {
                text: '烏坵鄉',
                value: 710512
            }]
        }, {
            text: '南投縣',
            value: 710600,
            children: [{
                text: '南投市',
                value: 710614
            }, {
                text: '中寮鄉',
                value: 710615
            }, {
                text: '草屯鎮',
                value: 710616
            }, {
                text: '國姓鄉',
                value: 710617
            }, {
                text: '埔里鎮',
                value: 710618
            }, {
                text: '仁愛鄉',
                value: 710619
            }, {
                text: '名間鄉',
                value: 710620
            }, {
                text: '集集鎮',
                value: 710621
            }, {
                text: '水里鄉',
                value: 710622
            }, {
                text: '魚池鄉',
                value: 710623
            }, {
                text: '信義鄉',
                value: 710624
            }, {
                text: '竹山鎮',
                value: 710625
            }, {
                text: '鹿谷鄉',
                value: 710626
            }]
        }, {
            text: '基隆市',
            value: 710700,
            children: [{
                text: '仁愛區',
                value: 710701
            }, {
                text: '信義區',
                value: 710702
            }, {
                text: '中正區',
                value: 710703
            }, {
                text: '中山區',
                value: 710704
            }, {
                text: '安樂區',
                value: 710705
            }, {
                text: '暖暖區',
                value: 710706
            }, {
                text: '七堵區',
                value: 710707
            }, {
                text: '其它區',
                value: 710799
            }]
        }, {
            text: '新竹市',
            value: 710800,
            children: [{
                text: '東區',
                value: 710801
            }, {
                text: '北區',
                value: 710802
            }, {
                text: '香山區',
                value: 710803
            }, {
                text: '其它區',
                value: 710899
            }]
        }, {
            text: '嘉義市',
            value: 710900,
            children: [{
                text: '東區',
                value: 710901
            }, {
                text: '西區',
                value: 710902
            }, {
                text: '其它區',
                value: 710999
            }]
        }, {
            text: '新北市',
            value: 711100,
            children: [{
                text: '萬里區',
                value: 711130
            }, {
                text: '金山區',
                value: 711131
            }, {
                text: '板橋區',
                value: 711132
            }, {
                text: '汐止區',
                value: 711133
            }, {
                text: '深坑區',
                value: 711134
            }, {
                text: '石碇區',
                value: 711135
            }, {
                text: '瑞芳區',
                value: 711136
            }, {
                text: '平溪區',
                value: 711137
            }, {
                text: '雙溪區',
                value: 711138
            }, {
                text: '貢寮區',
                value: 711139
            }, {
                text: '新店區',
                value: 711140
            }, {
                text: '坪林區',
                value: 711141
            }, {
                text: '烏來區',
                value: 711142
            }, {
                text: '永和區',
                value: 711143
            }, {
                text: '中和區',
                value: 711144
            }, {
                text: '土城區',
                value: 711145
            }, {
                text: '三峽區',
                value: 711146
            }, {
                text: '樹林區',
                value: 711147
            }, {
                text: '鶯歌區',
                value: 711148
            }, {
                text: '三重區',
                value: 711149
            }, {
                text: '新莊區',
                value: 711150
            }, {
                text: '泰山區',
                value: 711151
            }, {
                text: '林口區',
                value: 711152
            }, {
                text: '蘆洲區',
                value: 711153
            }, {
                text: '五股區',
                value: 711154
            }, {
                text: '八里區',
                value: 711155
            }, {
                text: '淡水區',
                value: 711156
            }, {
                text: '三芝區',
                value: 711157
            }, {
                text: '石門區',
                value: 711158
            }]
        }, {
            text: '宜蘭縣',
            value: 711200,
            children: [{
                text: '宜蘭市',
                value: 711287
            }, {
                text: '頭城鎮',
                value: 711288
            }, {
                text: '礁溪鄉',
                value: 711289
            }, {
                text: '壯圍鄉',
                value: 711290
            }, {
                text: '員山鄉',
                value: 711291
            }, {
                text: '羅東鎮',
                value: 711292
            }, {
                text: '三星鄉',
                value: 711293
            }, {
                text: '大同鄉',
                value: 711294
            }, {
                text: '五結鄉',
                value: 711295
            }, {
                text: '冬山鄉',
                value: 711296
            }, {
                text: '蘇澳鎮',
                value: 711297
            }, {
                text: '南澳鄉',
                value: 711298
            }, {
                text: '釣魚台',
                value: 711299
            }]
        }, {
            text: '新竹縣',
            value: 711300,
            children: [{
                text: '竹北市',
                value: 711387
            }, {
                text: '湖口鄉',
                value: 711388
            }, {
                text: '新豐鄉',
                value: 711389
            }, {
                text: '新埔鎮',
                value: 711390
            }, {
                text: '關西鎮',
                value: 711391
            }, {
                text: '芎林鄉',
                value: 711392
            }, {
                text: '寶山鄉',
                value: 711393
            }, {
                text: '竹東鎮',
                value: 711394
            }, {
                text: '五峰鄉',
                value: 711395
            }, {
                text: '橫山鄉',
                value: 711396
            }, {
                text: '尖石鄉',
                value: 711397
            }, {
                text: '北埔鄉',
                value: 711398
            }, {
                text: '峨眉鄉',
                value: 711399
            }]
        }, {
            text: '桃園市',
            value: 711400,
            children: [{
                text: '中壢區',
                value: 711414
            }, {
                text: '平鎮區',
                value: 711415
            }, {
                text: '楊梅區',
                value: 711417
            }, {
                text: '新屋區',
                value: 711418
            }, {
                text: '觀音區',
                value: 711419
            }, {
                text: '桃園區',
                value: 711420
            }, {
                text: '龜山區',
                value: 711421
            }, {
                text: '八德區',
                value: 711422
            }, {
                text: '大溪區',
                value: 711423
            }, {
                text: '大園區',
                value: 711425
            }, {
                text: '蘆竹區',
                value: 711426
            }, {
                text: '龍潭區',
                value: 711489
            }, {
                text: '復興區',
                value: 711497
            }]
        }, {
            text: '苗栗縣',
            value: 711500,
            children: [{
                text: '頭份市',
                value: 711520
            }, {
                text: '竹南鎮',
                value: 711582
            }, {
                text: '頭份鎮',
                value: 711583
            }, {
                text: '三灣鄉',
                value: 711584
            }, {
                text: '南莊鄉',
                value: 711585
            }, {
                text: '獅潭鄉',
                value: 711586
            }, {
                text: '後龍鎮',
                value: 711587
            }, {
                text: '通霄鎮',
                value: 711588
            }, {
                text: '苑里鎮',
                value: 711589
            }, {
                text: '苗栗市',
                value: 711590
            }, {
                text: '造橋鄉',
                value: 711591
            }, {
                text: '頭屋鄉',
                value: 711592
            }, {
                text: '公館鄉',
                value: 711593
            }, {
                text: '大湖鄉',
                value: 711594
            }, {
                text: '泰安鄉',
                value: 711595
            }, {
                text: '銅鑼鄉',
                value: 711596
            }, {
                text: '三義鄉',
                value: 711597
            }, {
                text: '西湖鄉',
                value: 711598
            }, {
                text: '卓蘭鎮',
                value: 711599
            }]
        }, {
            text: '彰化縣',
            value: 711700,
            children: [{
                text: '員林市',
                value: 711736
            }, {
                text: '彰化市',
                value: 711774
            }, {
                text: '芬園鄉',
                value: 711775
            }, {
                text: '花壇鄉',
                value: 711776
            }, {
                text: '秀水鄉',
                value: 711777
            }, {
                text: '鹿港鎮',
                value: 711778
            }, {
                text: '福興鄉',
                value: 711779
            }, {
                text: '線西鄉',
                value: 711780
            }, {
                text: '和美鎮',
                value: 711781
            }, {
                text: '伸港鄉',
                value: 711782
            }, {
                text: '社頭鄉',
                value: 711784
            }, {
                text: '永靖鄉',
                value: 711785
            }, {
                text: '埔心鄉',
                value: 711786
            }, {
                text: '溪湖鎮',
                value: 711787
            }, {
                text: '大村鄉',
                value: 711788
            }, {
                text: '埔鹽鄉',
                value: 711789
            }, {
                text: '田中鎮',
                value: 711790
            }, {
                text: '北斗鎮',
                value: 711791
            }, {
                text: '田尾鄉',
                value: 711792
            }, {
                text: '埤頭鄉',
                value: 711793
            }, {
                text: '溪州鄉',
                value: 711794
            }, {
                text: '竹塘鄉',
                value: 711795
            }, {
                text: '二林鎮',
                value: 711796
            }, {
                text: '大城鄉',
                value: 711797
            }, {
                text: '芳苑鄉',
                value: 711798
            }, {
                text: '二水鄉',
                value: 711799
            }]
        }, {
            text: '嘉義縣',
            value: 711900,
            children: [{
                text: '番路鄉',
                value: 711982
            }, {
                text: '梅山鄉',
                value: 711983
            }, {
                text: '竹崎鄉',
                value: 711984
            }, {
                text: '阿里山鄉',
                value: 711985
            }, {
                text: '中埔鄉',
                value: 711986
            }, {
                text: '大埔鄉',
                value: 711987
            }, {
                text: '水上鄉',
                value: 711988
            }, {
                text: '鹿草鄉',
                value: 711989
            }, {
                text: '太保市',
                value: 711990
            }, {
                text: '樸子市',
                value: 711991
            }, {
                text: '東石鄉',
                value: 711992
            }, {
                text: '六腳鄉',
                value: 711993
            }, {
                text: '新港鄉',
                value: 711994
            }, {
                text: '民雄鄉',
                value: 711995
            }, {
                text: '大林鎮',
                value: 711996
            }, {
                text: '溪口鄉',
                value: 711997
            }, {
                text: '義竹鄉',
                value: 711998
            }, {
                text: '布袋鎮',
                value: 711999
            }]
        }, {
            text: '雲林縣',
            value: 712100,
            children: [{
                text: '斗南鎮',
                value: 712180
            }, {
                text: '大埤鄉',
                value: 712181
            }, {
                text: '虎尾鎮',
                value: 712182
            }, {
                text: '土庫鎮',
                value: 712183
            }, {
                text: '褒忠鄉',
                value: 712184
            }, {
                text: '東勢鄉',
                value: 712185
            }, {
                text: '台西鄉',
                value: 712186
            }, {
                text: '崙背鄉',
                value: 712187
            }, {
                text: '麥寮鄉',
                value: 712188
            }, {
                text: '斗六市',
                value: 712189
            }, {
                text: '林內鄉',
                value: 712190
            }, {
                text: '古坑鄉',
                value: 712191
            }, {
                text: '莿桐鄉',
                value: 712192
            }, {
                text: '西螺鎮',
                value: 712193
            }, {
                text: '二崙鄉',
                value: 712194
            }, {
                text: '北港鎮',
                value: 712195
            }, {
                text: '水林鄉',
                value: 712196
            }, {
                text: '口湖鄉',
                value: 712197
            }, {
                text: '四湖鄉',
                value: 712198
            }, {
                text: '元長鄉',
                value: 712199
            }]
        }, {
            text: '屏東縣',
            value: 712400,
            children: [{
                text: '崁頂鄉',
                value: 712451
            }, {
                text: '屏東市',
                value: 712467
            }, {
                text: '三地門鄉',
                value: 712468
            }, {
                text: '霧台鄉',
                value: 712469
            }, {
                text: '瑪家鄉',
                value: 712470
            }, {
                text: '九如鄉',
                value: 712471
            }, {
                text: '里港鄉',
                value: 712472
            }, {
                text: '高樹鄉',
                value: 712473
            }, {
                text: '鹽埔鄉',
                value: 712474
            }, {
                text: '長治鄉',
                value: 712475
            }, {
                text: '麟洛鄉',
                value: 712476
            }, {
                text: '竹田鄉',
                value: 712477
            }, {
                text: '內埔鄉',
                value: 712478
            }, {
                text: '萬丹鄉',
                value: 712479
            }, {
                text: '潮州鎮',
                value: 712480
            }, {
                text: '泰武鄉',
                value: 712481
            }, {
                text: '來義鄉',
                value: 712482
            }, {
                text: '萬巒鄉',
                value: 712483
            }, {
                text: '莰頂鄉',
                value: 712484
            }, {
                text: '新埤鄉',
                value: 712485
            }, {
                text: '南州鄉',
                value: 712486
            }, {
                text: '林邊鄉',
                value: 712487
            }, {
                text: '東港鎮',
                value: 712488
            }, {
                text: '琉球鄉',
                value: 712489
            }, {
                text: '佳冬鄉',
                value: 712490
            }, {
                text: '新園鄉',
                value: 712491
            }, {
                text: '枋寮鄉',
                value: 712492
            }, {
                text: '枋山鄉',
                value: 712493
            }, {
                text: '春日鄉',
                value: 712494
            }, {
                text: '獅子鄉',
                value: 712495
            }, {
                text: '車城鄉',
                value: 712496
            }, {
                text: '牡丹鄉',
                value: 712497
            }, {
                text: '恒春鎮',
                value: 712498
            }, {
                text: '滿州鄉',
                value: 712499
            }]
        }, {
            text: '台東縣',
            value: 712500,
            children: [{
                text: '台東市',
                value: 712584
            }, {
                text: '綠島鄉',
                value: 712585
            }, {
                text: '蘭嶼鄉',
                value: 712586
            }, {
                text: '延平鄉',
                value: 712587
            }, {
                text: '卑南鄉',
                value: 712588
            }, {
                text: '鹿野鄉',
                value: 712589
            }, {
                text: '關山鎮',
                value: 712590
            }, {
                text: '海端鄉',
                value: 712591
            }, {
                text: '池上鄉',
                value: 712592
            }, {
                text: '東河鄉',
                value: 712593
            }, {
                text: '成功鎮',
                value: 712594
            }, {
                text: '長濱鄉',
                value: 712595
            }, {
                text: '金峰鄉',
                value: 712596
            }, {
                text: '大武鄉',
                value: 712597
            }, {
                text: '達仁鄉',
                value: 712598
            }, {
                text: '太麻里鄉',
                value: 712599
            }]
        }, {
            text: '花蓮縣',
            value: 712600,
            children: [{
                text: '花蓮市',
                value: 712686
            }, {
                text: '新城鄉',
                value: 712687
            }, {
                text: '太魯閣',
                value: 712688
            }, {
                text: '秀林鄉',
                value: 712689
            }, {
                text: '吉安鄉',
                value: 712690
            }, {
                text: '壽豐鄉',
                value: 712691
            }, {
                text: '鳳林鎮',
                value: 712692
            }, {
                text: '光復鄉',
                value: 712693
            }, {
                text: '豐濱鄉',
                value: 712694
            }, {
                text: '瑞穗鄉',
                value: 712695
            }, {
                text: '萬榮鄉',
                value: 712696
            }, {
                text: '玉里鎮',
                value: 712697
            }, {
                text: '卓溪鄉',
                value: 712698
            }, {
                text: '富里鄉',
                value: 712699
            }]
        }, {
            text: '澎湖縣',
            value: 712700,
            children: [{
                text: '馬公市',
                value: 712794
            }, {
                text: '西嶼鄉',
                value: 712795
            }, {
                text: '望安鄉',
                value: 712796
            }, {
                text: '七美鄉',
                value: 712797
            }, {
                text: '白沙鄉',
                value: 712798
            }, {
                text: '湖西鄉',
                value: 712799
            }]
        }, {
            text: '連江縣',
            value: 712800,
            children: [{
                text: '南竿鄉',
                value: 712896
            }, {
                text: '北竿鄉',
                value: 712897
            }, {
                text: '東引鄉',
                value: 712898
            }, {
                text: '莒光鄉',
                value: 712899
            }]
        }]
    }, {
        text: '香港',
        value: 810000,
        children: [{
            text: '香港島',
            value: 810100,
            children: [{
                text: '中西區',
                value: 810101
            }, {
                text: '灣仔區',
                value: 810102
            }, {
                text: '東區',
                value: 810103
            }, {
                text: '南區',
                value: 810104
            }]
        }, {
            text: '九龍',
            value: 810200,
            children: [{
                text: '九龍城區',
                value: 810201
            }, {
                text: '油尖旺區',
                value: 810202
            }, {
                text: '深水埗區',
                value: 810203
            }, {
                text: '黃大仙區',
                value: 810204
            }, {
                text: '觀塘區',
                value: 810205
            }]
        }, {
            text: '新界',
            value: 810300,
            children: [{
                text: '北區',
                value: 810301
            }, {
                text: '大埔區',
                value: 810302
            }, {
                text: '沙田區',
                value: 810303
            }, {
                text: '西貢區',
                value: 810304
            }, {
                text: '元朗區',
                value: 810305
            }, {
                text: '屯門區',
                value: 810306
            }, {
                text: '荃灣區',
                value: 810307
            }, {
                text: '葵青區',
                value: 810308
            }, {
                text: '離島區',
                value: 810309
            }]
        }]
    }]
}


// WEBPACK FOOTER //
// ./src/util/area_list.js